<template>
    <GradientWithContent id="contact-form" class="form-contact relative">
        <template #content>
            <div class="xl:pl-30 2xl:pl-40">
                <div class="flex justify-center">
                    <h1 class="title-section-bold text-white px-3 md:text-center">
                        Tem uma nova ideia para o seu negócio e quer saber como podemos ajudar?
                    </h1>
                </div>
                <form
                    class="px-3 md:px-0 lg:grid grid-cols-12"
                    method="POST"
                    enctype="multipart/form-data"
                    @submit.prevent="submit"
                >
                    <div class="col-start-1 col-span-6 grid grid-cols-12 space-x-2 gap-6">
                        <input v-model="form.name" required type="text" name="name" placeholder="Nome" class="col-start-1 col-span-12 md:col-start-3 md:col-span-4">
                        <input v-model="form.company" required type="text" name="company" placeholder="Empresa" class="col-start-1 col-span-12 md:col-span-4">
                        <input v-model="form.phone" required type="tel" name="phone" placeholder="Telefone" class="col-start-1 col-span-12 md:col-span-3 md:col-start-3 m-0">
                        <input v-model="form.email" required type="email" name="email" placeholder="Email*" class="col-start-1 col-span-12 md:col-span-5 md:col-start-4 md:col-start-6">
                        <textarea v-model="form.idea" required name="idea" placeholder="Qual sua ideia ?" rows=5 cols="60" class="col-start-1 col-span-12 md:col-span-8 md:col-start-3"></textarea>

                        <div class="col-start-1 col-span-12 md:col-start-3 md:col-span-4">
                            <div class="flex items-center justify-center md:justify-start gap-4">
                                <button
                                    type="submit"
                                    class="submit-button bg-transparent text-xl hover:bg-white hover:text-blue-400 text-white font-semibold px-8 py-1 border-2 border-gray-100 hover:border-transparent rounded-full"
                                    :disabled="form.processing"
                                >
                                  {{ form.processing ? 'Enviando...' : 'Enviar' }}
                                </button>

                                <Transition
                                    enter-active-class="transition ease-in-out"
                                    enter-from-class="opacity-0"
                                    leave-active-class="transition ease-in-out"
                                    leave-to-class="opacity-0"
                                >
                                    <div v-if="form.recentlySuccessful" class="col-span-1 flex justify-center md:justify-end text-white">
                                        Enviado com sucesso!
                                    </div>
                                </Transition>
                            </div>
                        </div>
                    </div>
                    <div class="col-start-7 2xl:col-start-8 hidden lg:grid lg:grid-cols-12 col-end-13">
                        <div class="relative col-start-1 col-span-12">
                            <svg class="hidden md:block" viewBox="0 0 651 303" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M652 0C652.552 0 653 0.447715 653 1C653 1.55228 652.552 2 652 2V0ZM542.774 55L537 60.7735L531.226 55L537 49.2265L542.774 55ZM652 2H623.25V0H652V2ZM594.25 31V271.5H592.25V31H594.25ZM563.25 302.5H31V300.5H563.25V302.5ZM0 271.5V85H2V271.5H0ZM31 54H537V56H31V54ZM0 85C0 67.8792 13.8792 54 31 54V56C14.9837 56 2 68.9837 2 85H0ZM594.25 271.5C594.25 288.621 580.371 302.5 563.25 302.5V300.5C579.266 300.5 592.25 287.516 592.25 271.5H594.25ZM31 302.5C13.8792 302.5 0 288.621 0 271.5H2C2 287.516 14.9837 300.5 31 300.5V302.5ZM623.25 2C607.234 2 594.25 14.9837 594.25 31H592.25C592.25 13.8792 606.129 0 623.25 0V2Z" fill="white"/></svg>
                            <ul class="form-info-text">
                                <li class="list-text">Nossa equipe de especialistas entrará em contato em até 1 dia útil.</li>
                                <li class="list-text">Vamos conhecer melhor suas necessidades e definir como podemos trabalhar juntos no seu projeto.</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-start-1 col-span-12 md:grid md:grid-cols-12">
                        <recaptcha class="md:col-start-3 lg:col-start-2 col-span-7 py-5" />
                    </div>
                    <div class="md:grid md:grid-cols-12 lg:hidden">
                        <div class="relative col-start-3 col-span-12">
                            <svg class="hidden md:block" viewBox="0 0 651 303" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M652 0C652.552 0 653 0.447715 653 1C653 1.55228 652.552 2 652 2V0ZM542.774 55L537 60.7735L531.226 55L537 49.2265L542.774 55ZM652 2H623.25V0H652V2ZM594.25 31V271.5H592.25V31H594.25ZM563.25 302.5H31V300.5H563.25V302.5ZM0 271.5V85H2V271.5H0ZM31 54H537V56H31V54ZM0 85C0 67.8792 13.8792 54 31 54V56C14.9837 56 2 68.9837 2 85H0ZM594.25 271.5C594.25 288.621 580.371 302.5 563.25 302.5V300.5C579.266 300.5 592.25 287.516 592.25 271.5H594.25ZM31 302.5C13.8792 302.5 0 288.621 0 271.5H2C2 287.516 14.9837 300.5 31 300.5V302.5ZM623.25 2C607.234 2 594.25 14.9837 594.25 31H592.25C592.25 13.8792 606.129 0 623.25 0V2Z" fill="white"/></svg>
                            <ul class="form-info-text">
                                <li class="text-xl-size">Nossa equipe de especialistas entrará em contato em até 1 dia útil.</li>
                                <li class="text-xl-size">Vamos conhecer melhor suas necessidades e definir como podemos trabalhar juntos no seu projeto.</li>
                            </ul>
                        </div>
                    </div>
                </form>
            </div>
        </template>
    </GradientWithContent>
</template>

<script setup>
import { useForm } from '@inertiajs/inertia-vue3';
import GradientWithContent from '@/Components/GradientWithContent.vue';

const form = useForm({
    name: '',
    company: '',
    phone: '',
    email: '',
    idea: '',
});

const submit = () => {
    form.post(route('Contact'), {
        preserveScroll: true
    });
}
/*
import GradientWithContent from '../../GradientWithContent.vue';
import formSubmitHandler from '../../utils/FormIdeaSubmitHandler.js';
export default {
    components:{
        GradientWithContent,
    },
    mixins:[formSubmitHandler],
    data(){
        return {
            userName:'',
            userCompany:'',
            userPhone:'',
            userEmail:'',
            userIdea:'',
        }
    },

}
*/
</script>

<style lang="postcss" scoped>
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active{
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: white !important;
    font-size: 100%;
    @apply font-semibold;
}

/* .submit-button {
    display: relative;

} */

.title-section-bold{
    @apply mb-16;
}

.form-contact{
    @apply mt-20;

    & ::placeholder {
        @apply text-white text-xl;
    }

    &::-ms-input-placeholder {
        @apply text-white  text-xl;
    }

    &:-ms-input-placeholder {
        @apply text-white  text-xl;
    }

    & h1{
        max-width: 1000px;
        @apply mt-5;
    }

    & form > :first-child > * {
        background: none;
        margin: 0 !important;

        &:focus{
            outline: none;
        }

        @apply border-b-2 text-white;
    }

    & form > :first-child > :last-child {
        resize: none;
        @apply border-b-0;
    }
    & form > :first-child > :not(:last-child) {
        height: 30px;
    }

}
.form-info-text{
    top: 30%;
    left: 50px;
    list-style: none;

    @apply pl-5 pt-10 md:pl-0 md:pt-0 md:absolute text-white text-2xl space-y-5 max-w-lg;

    & li::before {
    content: "\2022";
    color: white;
    font-weight: bold;
    display: inline-block;
    width: 1em;
    margin-left: -1em;
    }
}

.list-text {
    max-width: 80%;
    line-height: 1.75rem;
}

li {
    @apply text-base;
}
</style>
